// 利用規約 / EULA（App Store Guideline 1.2 — 登録・ログイン前に提示される規約）
// 日本語と英語を切り替えられる。審査員は英語で読むため EN は必須。
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UPDATED = { ja: '最終更新日: 2026年8月7日', en: 'Last updated: August 7, 2026' };

const SECTIONS = {
  ja: [
    {
      icon: '🤝',
      title: '第1条 本規約への同意',
      body: [
        'JTALK（以下「本アプリ」）は、SE（以下「当社」）が提供する日本語学習コミュニティです。本アプリのアカウント登録・ログイン・ゲスト利用を行った時点で、利用者は本規約（エンドユーザー使用許諾契約・EULA）に同意したものとみなされます。同意いただけない場合は本アプリをご利用いただけません。',
        '13歳未満の方は本アプリをご利用いただけません。',
      ],
    },
    {
      icon: '🚫',
      title: '第2条 禁止コンテンツ・禁止行為（不寛容ポリシー）',
      lead: '当社は不適切なコンテンツおよび迷惑行為に対して一切の寛容を認めません（zero tolerance）。以下の投稿・送信・掲載を固く禁じます。',
      list: [
        '他者への嫌がらせ、いじめ、脅迫、ストーキング',
        '人種・国籍・民族・宗教・性別・性的指向・障害などに基づくヘイト表現や差別的表現',
        '性的・わいせつな表現、ヌード、性的サービスの勧誘',
        '未成年者を性的に描写・搾取する一切の内容',
        '暴力の描写・助長、violent extremism、テロ行為の称賛',
        '自傷行為・自殺・摂食障害を助長する内容',
        'スパム、詐欺、フィッシング、無断の宣伝・勧誘',
        '違法な薬物・武器・偽造品などの売買',
        '他者の個人情報の無断掲載、なりすまし、著作権侵害',
      ],
      note: '違反が確認された場合、当社は事前の通知なくコンテンツを削除し、当該アカウントを警告・一時停止・永久削除することができます。',
    },
    {
      icon: '🚩',
      title: '第3条 通報のしくみ',
      lead: '不適切なコンテンツを見つけた場合は、その場で通報できます。',
      list: [
        '投稿：投稿右上の「⋯」→「この投稿を通報する」／コメント：コメント右の「🚩 通報」',
        'ダイレクトメッセージ：メッセージ横の「🚩」（または長押し）→「このメッセージを通報する」。チャット画面右上の「⋯」からは相手ユーザーの通報・ブロックができます',
        'ユーザー：プロフィール画面の「🚩 通報」ボタン',
        'トークルーム：ルーム一覧のカードの「🚩」、またはルーム画面右上の「⋯」→「このルームを通報する」',
      ],
      note: '通報されたコンテンツは、通報した時点で通報者の画面から即座に非表示になります。当社は通報を24時間以内に確認し、本規約に違反していると判断した場合は当該コンテンツを削除し、投稿したユーザーの利用を停止します。同一コンテンツが複数の利用者から通報された場合は、確認完了を待たずに自動的に非表示となります。',
    },
    {
      icon: '🛡',
      title: '第4条 ブロックのしくみ',
      lead: '迷惑な利用者は、いつでもブロックできます。',
      list: [
        'プロフィール画面の「ブロック」ボタン、またはチャット画面の「⋯」→「ブロック」',
        'ブロックすると、相手の投稿・コメント・プロフィール・トークルームはタイムラインや検索に一切表示されなくなります',
        'ブロックした相手からのダイレクトメッセージ・通話・フォローは届かなくなります',
        'ブロックは相手に通知されません。設定 > 安全とプライバシー からいつでも解除できます',
      ],
    },
    {
      icon: '⚙️',
      title: '第5条 当社によるモデレーション',
      list: [
        '投稿・コメント・メッセージ・プロフィール・ルーム名には自動フィルタが適用され、明白な禁止語を含む内容は投稿できません',
        '当社はすべての通報を24時間以内に確認します',
        '当社は、本規約に違反すると判断したコンテンツを、事前の通知なく削除する権利を留保します',
        '重大な違反または違反の繰り返しがあった利用者は、アカウントを永久に停止します',
      ],
    },
    {
      icon: '👤',
      title: '第6条 利用者の責任',
      list: [
        '投稿したコンテンツの責任は投稿した利用者が負います',
        '本アプリは学習者同士の交流の場です。実際に会う場合を含め、利用者間のやり取りは自己責任で行ってください',
        'アカウント情報・パスワードの管理は利用者の責任で行ってください',
      ],
    },
    {
      icon: '💳',
      title: '第7条 有料プラン（自動更新サブスクリプション）',
      list: [
        '商品名：JTALK プレミアム（月額）',
        '購読期間：1か月（自動更新）。価格はアプリ内の購入画面に、お客様の地域の通貨で表示されます',
        '各購読期間中に提供される内容：ライブルームの時間無制限利用、プレミアム限定トークルーム、AI翻訳・AI添削の無制限利用、プレミアムバッジ',
        'JTALK Premium は自動更新サブスクリプションです。期間終了の24時間前までに解約しない限り、同じ価格で1か月ごとに自動更新されます',
        '料金は購入確定時に Apple ID アカウントへ請求されます',
        '解約は iOS の「設定 > Apple ID > サブスクリプション」から行えます',
      ],
    },
    {
      icon: '📄',
      title: '第8条 免責・規約の変更',
      list: [
        '本アプリは現状有姿で提供され、当社は利用者間のトラブルについて責任を負いません',
        '当社は必要に応じて本規約を変更することがあります。重要な変更はアプリ内でお知らせします',
        '本規約は日本法に準拠します',
      ],
    },
    {
      icon: '✉️',
      title: '第9条 お問い合わせ',
      body: [
        '規約違反の報告、アカウントに関するお問い合わせは jtalk.se1@gmail.com までご連絡ください。24時間以内に対応します。',
      ],
    },
  ],
  en: [
    {
      icon: '🤝',
      title: '1. Agreement to These Terms',
      body: [
        'JTALK ("the App") is a Japanese-language learning community operated by SE ("we"). By registering an account, logging in, or continuing as a guest, you agree to these Terms of Use (End User License Agreement / EULA). If you do not agree, you may not use the App.',
        'You must be at least 13 years old to use the App.',
      ],
    },
    {
      icon: '🚫',
      title: '2. Objectionable Content and Abusive Behavior — Zero Tolerance',
      lead: 'We have zero tolerance for objectionable content and abusive users. The following is strictly prohibited:',
      list: [
        'Harassment, bullying, threats, or stalking of any user',
        'Hate speech or discrimination based on race, nationality, ethnicity, religion, gender, sexual orientation, or disability',
        'Sexually explicit or pornographic content, nudity, or solicitation',
        'Any content that sexualizes or exploits minors',
        'Depiction or promotion of violence, violent extremism, or terrorism',
        'Content that promotes self-harm, suicide, or eating disorders',
        'Spam, fraud, phishing, or unsolicited advertising',
        'Sale of illegal drugs, weapons, or counterfeit goods',
        'Posting others’ personal information, impersonation, or copyright infringement',
      ],
      note: 'If a violation is confirmed, we may remove the content and warn, suspend, or permanently terminate the account without prior notice.',
    },
    {
      icon: '🚩',
      title: '3. Flagging Objectionable Content',
      lead: 'You can flag objectionable content anywhere it appears:',
      list: [
        'Posts and comments: tap "⋯" on the post → "Report"',
        'Direct messages: tap the message → "Report"',
        'Users: tap "⋯" on the profile → "Report"',
        'Talk rooms: tap "⋯" in the room → "Report"',
      ],
      note: 'Flagged content is hidden from the reporting user immediately. We review every report within 24 hours; content found to violate these Terms is removed and the responsible user is ejected from the service. Content flagged by multiple users is hidden automatically before review completes.',
    },
    {
      icon: '🛡',
      title: '4. Blocking Abusive Users',
      lead: 'You can block any abusive user at any time:',
      list: [
        'Use the "Block" button on the user’s profile, or "⋯" → "Block" in a chat',
        'A blocked user’s posts, comments, profile, and talk rooms no longer appear anywhere in your timeline or search',
        'Blocked users cannot send you direct messages, calls, or follow requests',
        'Blocking is never disclosed to the blocked user. You can undo it any time in Settings → Safety & Privacy',
      ],
    },
    {
      icon: '⚙️',
      title: '5. Our Moderation',
      list: [
        'An automated filter is applied to posts, comments, messages, profiles, and room names; content containing prohibited terms cannot be published',
        'We review all reports within 24 hours',
        'We reserve the right to remove any content we determine violates these Terms, without prior notice',
        'Users who commit serious or repeated violations are permanently removed from the service',
      ],
    },
    {
      icon: '👤',
      title: '6. Your Responsibilities',
      list: [
        'You are solely responsible for the content you post',
        'Interactions with other users, including meeting in person, are at your own risk',
        'You are responsible for keeping your account credentials secure',
      ],
    },
    {
      icon: '💳',
      title: '7. Auto-Renewable Subscription',
      list: [
        'Title: JTALK Premium (Monthly)',
        'Length of subscription: 1 month, auto-renewing. The price is shown in your local currency on the in-app purchase screen',
        'Services provided during each subscription period: unlimited live-room time, premium-only talk rooms, unlimited AI translation and AI correction, and a premium badge',
        'JTALK Premium is an auto-renewable subscription that renews at the same price every month unless cancelled at least 24 hours before the end of the current period',
        'Payment is charged to your Apple ID account at confirmation of purchase',
        'You can manage or cancel in iOS Settings → Apple ID → Subscriptions',
      ],
    },
    {
      icon: '📄',
      title: '8. Disclaimer and Changes',
      list: [
        'The App is provided "as is"; we are not liable for disputes between users',
        'We may update these Terms; material changes will be announced in the App',
        'These Terms are governed by the laws of Japan',
      ],
    },
    {
      icon: '✉️',
      title: '9. Contact',
      body: [
        'To report a violation or ask about your account, contact jtalk.se1@gmail.com. We respond within 24 hours.',
      ],
    },
  ],
};

const HERO = {
  ja: {
    kicker: '利用規約 / EULA',
    title: '安心して話せる場所を、みんなでつくる。',
    lead: 'JTALK は、嫌がらせや不適切な投稿を一切許容しません。通報は24時間以内に確認し、違反したコンテンツは削除、投稿者は利用停止となります。',
  },
  en: {
    kicker: 'Terms of Use / EULA',
    title: 'A place where everyone can speak safely.',
    lead: 'JTALK has zero tolerance for objectionable content and abusive behavior. Reports are reviewed within 24 hours; violating content is removed and its author is ejected.',
  },
};

export default function Terms() {
  const navigate = useNavigate();
  const [lang, setLang] = useState('ja');
  const t = HERO[lang];

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/', { replace: true });
  };

  return (
    <div className="tm-page">
      <style>{CSS}</style>

      <header className="tm-topbar">
        <button data-control="icon" data-control-id="Terms-tm-back" type="button" className="tm-back" onClick={goBack} aria-label={lang === 'ja' ? '戻る' : 'Back'}>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 6l-6 6 6 6" />
          </svg>
        </button>
        <span className="tm-topbar-title">{lang === 'ja' ? '利用規約' : 'Terms of Use'}</span>
        <div className="tm-lang" role="group" aria-label="Language">
          <button data-control="tab" data-control-id="Terms-tm-lang-btn"
            type="button"
            className={`tm-lang-btn ${lang === 'ja' ? 'is-active' : ''}`}
            aria-pressed={lang === 'ja'} onClick={() => setLang('ja')}
          >
            日本語
          </button>
          <button data-control="tab" data-control-id="Terms-tm-lang-btn"
            type="button"
            className={`tm-lang-btn ${lang === 'en' ? 'is-active' : ''}`}
            aria-pressed={lang === 'en'} onClick={() => setLang('en')}
          >
            EN
          </button>
        </div>
      </header>

      <div className="tm-inner" key={lang}>
        <section className="tm-hero">
          <span className="tm-kicker">{t.kicker}</span>
          <h1 className="tm-title">{t.title}</h1>
          <p className="tm-lead">{t.lead}</p>
          <span className="tm-updated">{UPDATED[lang]}</span>
        </section>

        <div className="tm-sections">
          {SECTIONS[lang].map((s) => (
            <section className="tm-card" key={s.title}>
              <div className="tm-card-head">
                <span className="tm-badge" aria-hidden="true">{s.icon}</span>
                <h2 className="tm-card-title">{s.title}</h2>
              </div>
              {s.lead ? <p className="tm-card-lead">{s.lead}</p> : null}
              {s.body?.map((p) => (
                <p className="tm-p" key={p}>{p}</p>
              ))}
              {s.list ? (
                <ul className="tm-list">
                  {s.list.map((li) => (
                    <li className="tm-li" key={li}>{li}</li>
                  ))}
                </ul>
              ) : null}
              {s.note ? <p className="tm-note">{s.note}</p> : null}
            </section>
          ))}
        </div>

        <p className="tm-footer-link">
          <a href="/privacy" className="tm-link">
            {lang === 'ja' ? 'プライバシーポリシー' : 'Privacy Policy'}
          </a>
        </p>
      </div>
    </div>
  );
}

const CSS = `
.tm-page {
  min-height: 100vh;
  background: var(--bg);
  padding-bottom: calc(32px + env(safe-area-inset-bottom));
}
.tm-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--surface);
  border-bottom: 1px solid var(--border-light);
}
.tm-back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border: none;
  border-radius: 9999px;
  background: var(--bg);
  color: var(--text);
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.2s;
}
.tm-back:hover { transform: translateY(-2px); background: var(--primary-ultra); color: var(--primary-dark); }
.tm-topbar-title {
  flex: 1;
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.02em;
}
.tm-lang {
  display: flex;
  gap: 2px;
  padding: 3px;
  border-radius: 9999px;
  background: var(--bg);
  flex-shrink: 0;
}
.tm-lang-btn {
  padding: 5px 12px;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 800;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.tm-lang-btn.is-active {
  background: var(--surface);
  color: var(--primary-dark);
  box-shadow: var(--shadow-sm);
}
.tm-inner {
  max-width: 480px;
  margin: 0 auto;
  padding: 0 16px;
  animation: tm-in 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
@keyframes tm-in {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}
.tm-hero {
  padding: 26px 20px 22px;
  margin: 16px 0 14px;
  border-radius: 20px;
  background: var(--app-gradient);
  box-shadow: 0 10px 26px rgba(16, 185, 129, 0.28);
  color: #FFFFFF;
}
.tm-kicker {
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 12px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.22);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
}
.tm-title {
  margin: 0 0 10px;
  font-size: 23px;
  font-weight: 900;
  line-height: 1.35;
  letter-spacing: -0.03em;
}
.tm-lead {
  margin: 0 0 14px;
  font-size: 13.5px;
  line-height: 1.7;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}
.tm-updated {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.75);
}
.tm-sections { display: flex; flex-direction: column; gap: 10px; }
.tm-card {
  padding: 18px 18px 16px;
  border-radius: var(--r-card);
  background: var(--surface);
  border: 1px solid var(--border-light);
}
.tm-card-head { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
.tm-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 12px;
  background: var(--primary-ultra);
  font-size: 17px;
}
.tm-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.02em;
  line-height: 1.4;
}
.tm-card-lead {
  margin: 0 0 10px;
  font-size: 13.5px;
  line-height: 1.7;
  font-weight: 700;
  color: var(--text);
}
.tm-p {
  margin: 0 0 8px;
  font-size: 13.5px;
  line-height: 1.75;
  color: var(--text-secondary);
}
.tm-p:last-child { margin-bottom: 0; }
.tm-list { margin: 0; padding: 0; list-style: none; }
.tm-li {
  position: relative;
  padding-left: 18px;
  margin-bottom: 7px;
  font-size: 13.5px;
  line-height: 1.7;
  color: var(--text-secondary);
}
.tm-li::before {
  content: '';
  position: absolute;
  left: 2px;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: var(--primary);
}
.tm-li:last-child { margin-bottom: 0; }
.tm-note {
  margin: 12px 0 0;
  padding: 11px 13px;
  border-radius: var(--r-input);
  background: var(--primary-ultra);
  font-size: 12.5px;
  line-height: 1.7;
  font-weight: 700;
  color: var(--primary-dark);
}
.tm-footer-link { margin: 20px 0 0; text-align: center; font-size: 13px; }
.tm-link { color: var(--primary-dark); font-weight: 800; text-decoration: none; }
@media (prefers-reduced-motion: reduce) {
  .tm-inner { animation: none; }
  .tm-back, .tm-lang-btn { transition: none; }
}
`;
